/*** IMPORTS FROM imports-loader ***/
(function() {
var define = false;

'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _createClass = require('babel-runtime/helpers/create-class')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _extends = require('babel-runtime/helpers/extends')['default'];

var _Promise = require('babel-runtime/core-js/promise')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

var _interopRequireWildcard = require('babel-runtime/helpers/interop-require-wildcard')['default'];

exports.__esModule = true;

var _settings = require('../../settings');

var _settings2 = _interopRequireDefault(_settings);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactGa = require('react-ga');

var _reactGa2 = _interopRequireDefault(_reactGa);

var _reactMotion = require('react-motion');

var _reactRedux = require('react-redux');

var _reduxModulesResponsive = require('redux/modules/responsive');

var viewportActions = _interopRequireWildcard(_reduxModulesResponsive);

var _reduxModulesNavSections = require('redux/modules/navSections');

var _reduxModulesNavSpecialSeries = require('redux/modules/navSpecialSeries');

var _reduxModulesCategories = require('redux/modules/categories');

var _reduxModulesAuthors = require('redux/modules/authors');

var _reduxModulesSubscribeModal = require('redux/modules/subscribeModal');

var _components = require('components');

var _reduxRouter = require('redux-router');

if (__CLIENT__) {
	require('../../../node_modules/waypoints/lib/jquery.waypoints');
}

var App = (function (_Component) {
	_inherits(App, _Component);

	function App() {
		_classCallCheck(this, _App);

		_Component.apply(this, arguments);

		this.state = {
			isStuck: false,
			modalIsOpenIsVisible: false
		};
	}

	App.prototype.componentDidMount = function componentDidMount() {
		var _this = this;
		var setViewportSize = this.props.setViewportSize;

		// Initialize Analytics and register a pageview
		_reactGa2['default'].initialize('UA-9731068-1', { debug: false });
		_reactGa2['default'].pageview(this.props.location.pathname);

		/**
   * Set up Enquire.js to watch the viewport size and change the store
   * accordingly. Any component that needs access to this state can use
   * @connect.
   */
		var enquire = require('static/js/enquire');
		enquire.register('' + _settings2['default'].media.smallViewport, {
			match: function match() {
				setViewportSize('isSmallViewport');
			}
		});
		enquire.register('' + _settings2['default'].media.mediumViewport, {
			match: function match() {
				setViewportSize('isMediumViewport');
			}
		});
		enquire.register('' + _settings2['default'].media.largeViewport, {
			match: function match() {
				setViewportSize('isLargeViewport');
			}
		});

		/**
   * Fire up Waypoints Sticky
   */
		/* eslint no-new: 0 */
		/* eslint no-undef: 0 */
		var theApp = _reactDom2['default'].findDOMNode(this.refs.theApp);
		new Waypoint({
			element: theApp,
			handler: function handler(direction) {
				_this.setState({
					isStuck: direction === 'down'
				});
			}
		});
	};

	App.prototype.componentWillUpdate = function componentWillUpdate(nextProps) {
		if (nextProps.location.pathname !== this.props.location.pathname) {
			_reactGa2['default'].pageview(nextProps.location.pathname);
		}
	};

	App.fetchData = function fetchData(getState, dispatch) {
		var promises = [];
		var state = getState();

		if (!_reduxModulesNavSections.isLoaded(state)) {
			promises.push(dispatch(_reduxModulesNavSections.load()));
		}

		if (!_reduxModulesNavSpecialSeries.isLoaded(state)) {
			promises.push(dispatch(_reduxModulesNavSpecialSeries.load()));
		}

		if (!_reduxModulesCategories.isLoaded(state)) {
			promises.push(dispatch(_reduxModulesCategories.load()));
		}

		if (!_reduxModulesAuthors.isLoaded(state)) {
			promises.push(dispatch(_reduxModulesAuthors.load()));
		}

		return _Promise.all(promises);
	};

	App.prototype.toggleGrid = function toggleGrid(event) {
		event.preventDefault();
		event.target.classList.toggle('Grid--expanded');
	};

	App.prototype.render = function render() {
		var _classNames,
		    _this2 = this;

		var styles = require('./App.css');

		var appClasses = _classnames2['default']((_classNames = {}, _classNames[styles.Base] = true, _classNames[styles['Base--isStuck']] = this.state.isStuck, _classNames));

		var _props = this.props;
		var children = _props.children;
		var modalIsOpen = _props.modalIsOpen;

		return _react2['default'].createElement(
			'div',
			{ className: styles.AppWrapper },
			_react2['default'].createElement(
				'div',
				{ className: appClasses, ref: 'theApp' },
				_react2['default'].createElement(_reactHelmet2['default'], _config2['default'].app.head),
				__DEVELOPMENT__ && _react2['default'].createElement(
					'a',
					{ href: '#grid', className: styles.Grid, id: 'grid', onClick: this.toggleGrid },
					_react2['default'].createElement(
						'div',
						{ className: styles.GridWrapper },
						_react2['default'].createElement('div', null),
						_react2['default'].createElement('div', null),
						_react2['default'].createElement('div', null),
						_react2['default'].createElement('div', null),
						_react2['default'].createElement('div', null),
						_react2['default'].createElement('div', null),
						_react2['default'].createElement('div', null),
						_react2['default'].createElement('div', null),
						_react2['default'].createElement('div', null),
						_react2['default'].createElement('div', null),
						_react2['default'].createElement('div', null),
						_react2['default'].createElement('div', null),
						_react2['default'].createElement('div', null),
						_react2['default'].createElement('div', null),
						_react2['default'].createElement('div', null),
						_react2['default'].createElement('div', null),
						_react2['default'].createElement('div', null),
						_react2['default'].createElement('div', null),
						_react2['default'].createElement('div', null),
						_react2['default'].createElement('div', null),
						_react2['default'].createElement('div', null),
						_react2['default'].createElement('div', null),
						_react2['default'].createElement('div', null),
						_react2['default'].createElement('div', null),
						_react2['default'].createElement('div', null),
						_react2['default'].createElement('div', null),
						_react2['default'].createElement('div', null),
						_react2['default'].createElement('div', null),
						_react2['default'].createElement('div', null),
						_react2['default'].createElement('div', null),
						_react2['default'].createElement('div', null),
						_react2['default'].createElement('div', null),
						_react2['default'].createElement('div', null),
						_react2['default'].createElement('div', null),
						_react2['default'].createElement('div', null),
						_react2['default'].createElement('div', null)
					)
				),
				_react2['default'].createElement(_components.Masthead, null),
				_react2['default'].createElement(
					'div',
					{ className: styles.Content },
					children
				)
			),
			_react2['default'].createElement(_components.SiteFooter, null),
			modalIsOpen && _react2['default'].createElement(
				'div',
				{ className: styles.Modal },
				_react2['default'].createElement(
					_reactMotion.Motion,
					{ defaultStyle: { opacity: 0 }, style: { opacity: _reactMotion.spring(1) } },
					function (_ref) {
						var opacity = _ref.opacity;
						return _react2['default'].createElement('div', { className: styles.ModalOverlay, onClick: _this2.props.closeModal, style: {
								opacity: '' + opacity
							} });
					}
				),
				_react2['default'].createElement(
					_reactMotion.Motion,
					{ defaultStyle: { y: -20 }, style: { y: _reactMotion.spring(0) } },
					function (_ref2) {
						var y = _ref2.y;
						return _react2['default'].createElement(
							'div',
							{ className: styles.ModalContent, style: {
									WebkitTransform: 'translate3d(-50%, calc(-50% + ' + y + 'px), 0)',
									transform: 'translate3d(-50%, calc(-50% + ' + y + 'px), 0)'
								} },
							_react2['default'].createElement('div', { className: styles.Close, onClick: _this2.props.closeModal }),
							_react2['default'].createElement(
								'h1',
								{ className: styles.Header },
								'Fresh News Comin’ Your Way'
							),
							_react2['default'].createElement(_components.NewsletterModal, null)
						);
					}
				)
			)
		);
	};

	_createClass(App, null, [{
		key: 'propTypes',
		value: {
			authors: _react.PropTypes.array,
			categories: _react.PropTypes.array,
			children: _react.PropTypes.object,
			closeModal: _react.PropTypes.func.isRequired,
			location: _react.PropTypes.shape({
				pathname: _react.PropTypes.string
			}),
			modalIsOpen: _react.PropTypes.bool,
			navSections: _react.PropTypes.array,
			pushState: _react.PropTypes.func,
			setViewportSize: _react.PropTypes.func,
			specialSeries: _react.PropTypes.array
		},
		enumerable: true
	}, {
		key: 'contextTypes',
		value: {
			store: _react.PropTypes.object.isRequired
		},
		enumerable: true
	}]);

	var _App = App;
	App = _reactRedux.connect(function (state) {
		return {
			authors: state.authors.data,
			categories: state.categories.data,
			modalIsOpen: state.subscribeModal.isOpen,
			navSections: state.navSections.data,
			specialSeries: state.navSpecialSeries.data,
			isSmallViewport: state.responsive.isSmallViewport,
			isMediumViewport: state.responsive.isMediumViewport,
			isLargeViewport: state.responsive.isLargeViewport
		};
	}, _extends({ pushState: _reduxRouter.pushState, closeModal: _reduxModulesSubscribeModal.close }, viewportActions))(App) || App;
	return App;
})(_react.Component);

exports['default'] = App;
module.exports = exports['default'];
/* Subscribe Modal */
}.call(window));


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/App/App.js
 ** module id = 698
 ** module chunks = 0
 **/